export default __webpack_public_path__ + "static/media/the_crypto_updates_logo_mobile.daca953f.png";